import { useJobHistory } from '@/api/queries'
import type { JobHistoryEntry, ScheduledJob } from '@/api/types'
import { DataTable, type Column } from '@/components/DataTable/DataTable'
import { Badge } from '@/components/ui/Badge'
import { Modal } from '@/components/ui/Modal'
import { dateTime } from '@/lib/format'
import styles from './scheduler.module.css'

const columns: Column<JobHistoryEntry>[] = [
  { key: 'run', header: 'Run at', width: '150px', render: (h) => dateTime(h.run, 'yyyy-MM-dd HH:mm:ss') },
  {
    key: 'success',
    header: 'Result',
    width: '90px',
    render: (h) => <Badge tone={h.success === null ? 'neutral' : h.success ? 'ok' : 'danger'}>{h.success === null ? 'pending' : h.success ? 'success' : 'failed'}</Badge>,
  },
  { key: 'nextExecution', header: 'Next run', width: '150px', render: (h) => dateTime(h.nextExecution) },
  {
    key: 'message',
    header: 'Message',
    render: (h) => (
      <span className={styles.message} title={h.message ?? undefined}>
        {h.message ?? '–'}
      </span>
    ),
  },
]

export function JobHistoryDialog({ job, onClose }: { job: ScheduledJob; onClose: () => void }) {
  const { data, isLoading, error } = useJobHistory(job.id)
  return (
    <Modal title={`${job.name} · history`} onClose={onClose} size="lg">
      <DataTable
        columns={columns}
        rows={data}
        rowKey={(h) => `${h.run}:${h.id}`}
        loading={isLoading}
        error={error}
        searchable
        searchPlaceholder="Search a run or message"
        dense
        initialSort={{ key: 'run', direction: 'desc' }}
        emptyMessage="No execution recorded"
        expandable={(h) => <pre className={styles.details}>{h.message ?? 'No message recorded'}</pre>}
      />
    </Modal>
  )
}
